import { memo } from "react";
import { formatKm } from "services/api/fleet/tires/helpers";
import { NumberField } from "ui/components/TextField/NumberField";
import { TireSetKmFieldProps } from "./types";

/**
 * Unos trenutne kilometraže vozila kod montaže i skidanja seta guma.
 * Pored polja stoji polje proslijeđeno kao children (datum), a ispod poznate kilometraže vozila i seta.
 */
const TireSetKmField: React.FC<TireSetKmFieldProps> = (props) => {
  const { value, onChange, error, vehicleKm, mountKm, children } = props;

  const isBelowVehicleKm = value != null && vehicleKm != null && value < vehicleKm;
  const distance = value != null && mountKm != null && value >= mountKm ? value - mountKm : null;
  const hasInfo = vehicleKm != null || mountKm != null;

  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <NumberField
            name="kmTraveled"
            label="Trenutna kilometraža vozila"
            placeholder="Unesite kilometražu..."
            value={value}
            onChange={onChange}
            error={error}
            groupAppend="km"
            size="full"
            decimals={0}
            min={0}
            required
          />
        </div>
        {children}
      </div>

      {hasInfo && (
        <div className="mt-3 border border-slate-200 bg-slate-50 rounded-sm px-4 py-1 divide-y divide-slate-200">
          {vehicleKm != null && (
            <div className="flex justify-between py-1.5 text-sm">
              <span className="text-slate-500">Zadnja evidentirana</span>
              <span className="text-slate-700 tabular-nums">{formatKm(vehicleKm)}</span>
            </div>
          )}
          {mountKm != null && (
            <div className="flex justify-between py-1.5 text-sm">
              <span className="text-slate-500">Kod montaže</span>
              <span className="text-slate-700 tabular-nums">{formatKm(mountKm)}</span>
            </div>
          )}
          {mountKm != null && (
            <div className="flex justify-between py-1.5 text-sm">
              <span className="text-slate-700 font-medium">Prijeđeno u ovoj montaži</span>
              <span className="text-slate-900 font-semibold tabular-nums">{formatKm(distance)}</span>
            </div>
          )}
        </div>
      )}

      {isBelowVehicleKm && (
        <div className="mt-3 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-sm px-3 py-2">
          Unesena kilometraža je manja od zadnje evidentirane kilometraže vozila. Provjerite unos prije nastavka.
        </div>
      )}
    </>
  );
};

export default memo(TireSetKmField);
